import React, { useState, useContext } from 'react';
import { Button, Card, Row, Col, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { requestValid } from 'api/user';
import sfimsLightLogo from 'assets/img/logo/light/SFIMS_logo.png';
import sfimsDarkLogo from 'assets/img/logo/dark/SFIMS_logo.png';
import AppContext from 'context/Context';
import { onInputChange } from 'function/event';
import { getText } from 'function/language';
import { getErrorMessage } from 'function/message';
import { useConfirmModalState } from 'global/confirmModalState';
import useObjReducer from 'hooks/useObjReducer';
import { RESPONSE_CODE } from 'types/const';

/**
 * 마이 페이지 - 패스워드 입력
 */
const Valid = ({ userId, onValid }) => {
  /* context */
  const {
    config: { isDark }
  } = useContext(AppContext);

  /* recoil */
  const { setConfirmModal } = useConfirmModalState();

  /* state */
  // 패스워드 재확인 비활성화 여부
  const [isDisableValid, setIsDisableValid] = useState(false);
  // 유효성 여부
  const [isInvalid, setIsInvalid] = useState(false);
  // 패스워드 재확인 요청 데이터
  const [validData, setValidData] = useObjReducer({ userPwd: '' });

  /* event */
  // 패스워드 재확인
  const onSubmit = async event => {
    event.preventDefault();

    if (!event.currentTarget.checkValidity()) {
      setIsInvalid(true);

      return;
    }

    setIsDisableValid(true);

    try {
      const { code, message } = await requestValid(validData);

      if (code !== RESPONSE_CODE.Success) {
        throw {
          code,
          error: message
        };
      }

      // 패스워드 재확인 시 이벤트 실행
      onValid();
    } catch (error) {
      setConfirmModal({
        isOpen: true,
        message: getErrorMessage(error?.code, error?.error)
      });
      setIsDisableValid(false);
    }
  };

  /* view */
  return (
    <Row className="flex-center">
      <Col sm={10} md={8} lg={6} xl={5} className="col-xxl-4">
        <div className="d-flex flex-center mb-3">
          <img
            src={isDark ? sfimsDarkLogo : sfimsLightLogo}
            alt="1"
            className="mb-2"
            width={336}
          />
        </div>
        <p className="fs-0 text-black text-center">{getText('sfims')}</p>
        <p
          className="fs-0 text-danger text-center fw-bold"
          style={{ whiteSpace: 'pre-line' }}
        >
          {getText('validUserPwd')}
        </p>
        <Card>
          <Card.Body className="p-4 p-sm-5">
            <Form validated={isInvalid} noValidate onSubmit={onSubmit}>
              <Form.Group className="mb-3">
                <Form.Control
                  readOnly
                  type="text"
                  value={userId}
                  placeholder={getText('userId')}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control
                  type="password"
                  value={validData.userPwd}
                  autoFocus
                  name="userPwd"
                  placeholder={getText('userPwd')}
                  required
                  onChange={event => onInputChange(event, setValidData)}
                />
              </Form.Group>
              <Form.Group>
                <Button
                  disabled={isDisableValid}
                  type="submit"
                  className="w-100"
                  color="primary"
                >
                  {getText('login')}
                </Button>
              </Form.Group>
            </Form>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

Valid.propTypes = {
  // 로그인 ID
  userId: PropTypes.string,

  // 패스워드 재확인 시 이벤트
  onValid: PropTypes.func
};

export default Valid;
